<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title>
        <h4>{{ $t('dashboard.today_picking') }}</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table :headers="headers" :items="projects" hide-actions class="elevation-0">
          <template slot="items" slot-scope="props">
            <td>
              <v-avatar size="36px" color="teal">
                <span class="white--text headline">{{ props.item.username }}</span>
              </v-avatar>
            </td>
            <td>{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.deadline }}</td>
            <td class="text-xs-left">
              <v-progress-linear :value="props.item.progress" height="5" :color="props.item.color"></v-progress-linear>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
// import { Projects } from '@/api/project';

import DashboardService from "@/services/DashboardService";

export default {
  data() {
    return {
      headers: [
        {
          text: "",
          align: "center",
          sortable: false,
          value: "avatar"
        },
        {
          text: "Name",
          align: "left",

          sortable: false,
          value: "name"
        },
        { text: "Num of Boxs", value: "deadline" },
        { text: "Progress", value: "progress" }
      ],
      projects: []
    };
  },
  computed: {
  },
  methods: {
    async fetchUserPackingData() {
      await DashboardService.getPickByUsers().then(res => {
        if (res.success) {
          let allPacks = res.data.reduce((sum, number) => {
            return sum + number.boxes;
          }, 0);

          let packersfetch = [];
          res.data.forEach(function(packer) {
            // console.log(packer);
            packersfetch.push({
              username: packer.messenger_name[0],
              name: packer.messenger_name,
              deadline: packer.boxes,
              progress: (packer.boxes / allPacks) * 100
            });
          });

          this.projects = packersfetch;

          setTimeout(() => {
            this.fetchUserPackingData();
            }, 60000);
        }
      });
    }
  },
  created() {
    this.fetchUserPackingData();
  }
};
</script>
